import { connect } from 'react-redux'
import { CollaborativeIndexation } from './CollaborativeIndexation.jsx'
import {
    areCollaborativeIndexationsDisplayed,
    getCollaborativeIndexationSelection,
    getCollaborativeIndexationsZones,
    isCollaborativeIndexationCreationSelectionToolActive,
} from '../../../../redux/collaborativeIndexations/selectors'

const mapStateToProps = (state) => ({
    zones: getCollaborativeIndexationsZones(state),
    selection: getCollaborativeIndexationSelection(state),
    areCollaborativeIndexationsDisplayed: areCollaborativeIndexationsDisplayed(state),
    isSelectionToolActive: isCollaborativeIndexationCreationSelectionToolActive(state),
})

export const CollaborativeIndexationContainer = connect(
    mapStateToProps,
)(CollaborativeIndexation)
